export default __webpack_public_path__ + "static/qt-sweetcombe-marque-3-star-gold-rgb-26aa7282210d1b745f1226a3e6baf6d8.png";